export enum EPermission {
  // Provider Management Permissions
  ProviderConfigView = "providerConfig:view",
  ProviderConfigProfileAdvancedManage = "providerConfigProfileAdvanced:manage",
  ProviderConfigPricingManage = "providerConfigPricing:manage",
  ProviderConfigPricingFixedManage = "providerConfigPricingFixed:manage",
  ProviderConfigBrandingManage = "providerConfigBranding:manage",
  ProviderConfigVehicleManage = "providerConfigVehicle:manage",
  ProviderConfigTransferTypesAdvancedManage = "providerConfigTransferTypesAdvanced:manage",
  ProviderConfigKeyManage = "providerConfigKey:manage",

  // User Management Permissions
  ProviderDriverManage = "providerDriver:manage",
  ProviderClientManage = "providerClient:manage",
  ProviderAccountDirectoryManage = "providerAccountDirectory:manage",

  // Feature Permissions
  ProviderAccreditationsManage = "providerAccreditations:manage",
  ProviderExternalSupplierManage = "providerExternalSupplier:manage",
  ProviderPrivateNetworkView = "providerPrivateNetwork:view",
  ProviderPrivateNetworkManage = "providerPrivateNetwork:manage",
  ProviderAddOnsManage = "providerAddOns:manage",
  ProviderQuickSetupManage = "providerQuickSetup:manage",
  ProviderGetStartedManage = "providerGetStarted:manage",
  FaProviderManage = "faProvider:manage",

  // Payment & Invoice Permissions
  ProviderPaymentsView = "providerPayments:view",
  ProviderPaymentsConfigManage = "providerPaymentsConfig:manage",
  ProviderPaymentsInvoiceManage = "providerPaymentsInvoice:manage",
  ProviderPaymentsInvoiceSetupManage = "providerPaymentsInvoiceSetup:manage",
  ProviderCompanyView = "providerCompany:view",
  ProviderCompanyManage = "providerCompany:manage",
  ProviderCompanyAdvancedManage = "providerCompanyAdvanced:manage",
  ProviderCompanyInvoicingView = "providerCompanyInvoicing:view",
  ProviderCompanyInvoicingManage = "providerCompanyInvoicing:manage",

  // Pricing Permissions
  ContractPricingProfileManage = "contractPricingProfile:manage",
  CustomRatesManage = "customRates:manage",

  // Reporting & Rating Permissions
  ProviderRatingManagerView = "providerRatingManager:view",
  ProviderRatingDriverManage = "providerRatingDriver:manage",
  ProviderReportingTripView = "providerReportingTrip:view",
  ProviderReportingTripManage = "providerReportingTrip:manage",

  // Vehicle & Booking Permissions
  ProviderVehicleManagerManage = "providerVehicleManager:manage",
  ProviderBookingMgrPlanningManage = "providerBookingMgrPlanning:manage",
  ProviderBookingMgrManage = "providerBookingMgr:manage",

  // Driver-Specific Permissions
  ProfileView = "profile:view",
  FleetLeaderAvailable = "fleetLeader:available",
  DebugAccessView = "debugAccess:view",

  // Component-Level Permissions
  DashboardNotesManage = "dashboardNotes:manage",
  DriverUpdateManage = "driverUpdate:manage",
  BookingReassignClientManage = "bookingReassignClient:manage",
  DriverIncidentManage = "driverIncident:manage",
  InstantQuoteView = "instantQuote:view",
  ClientQRCodeView = "clientQRCode:view",
  VehicleOwnerFeeManage = "vehicleOwnerFee:manage",
  CustomServiceAgreementManage = "customServiceAgreement:manage",

  // Config Permissions - Business Settings
  ProviderConfigBusinessDetailsManage = "providerConfigBusinessDetails:manage",
  ProviderConfigOperatorBrandingManage = "providerConfigOperatorBranding:manage",
  ProviderConfigWebsiteDetailsManage = "providerConfigWebsiteDetails:manage",
  ProviderConfigEmailNotificationsManage = "providerConfigEmailNotifications:manage",
  ProviderConfigSmsVoiceNotificationsManage = "providerConfigSmsVoiceNotifications:manage",
  ProviderConfigAccessControlManage = "providerConfigAccessControl:manage",
  ProviderConfigDisplayOptionsManage = "providerConfigDisplayOptions:manage",
  ProviderConfigDisplayOptionsAdvancedManage = "providerConfigDisplayOptionsAdvanced:manage",

  // Config Permissions - Trip Settings
  ProviderConfigTripCostManage = "providerConfigTripCost:manage",
  ProviderConfigTimeAndDayManage = "providerConfigTimeAndDay:manage",
  ProviderConfigHourlyDailyHireManage = "providerConfigHourlyDailyHire:manage",
  ProviderConfigUnscheduledStopsManage = "providerConfigUnscheduledStops:manage",
  ProviderConfigCancellationFeesManage = "providerConfigCancellationFees:manage",
  ProviderConfigBillingSettingsManage = "providerConfigBillingSettings:manage",
  ProviderConfigBillingSettingsAdvancedManage = "providerConfigBillingSettingsAdvanced:manage",
  ProviderConfigWaitingTimesManage = "providerConfigWaitingTimes:manage",
  ProviderConfigDispatchManage = "providerConfigDispatch:manage",
  ProviderConfigDispatchOffloadingManage = "providerConfigDispatchOffloading:manage",
  ProviderConfigVehicleCategoriesAdvancedManage = "providerConfigVehicleCategoriesAdvanced:manage",

  ProviderConfigTripSettingsManage = "providerConfigTripSettings:manage",
  ProviderConfigMarketingToolManage = "providerConfigMarkettingTool:manage",
  ProviderConfigUserAccountsManage = "providerConfigUserAccounts:manage",
}
